<template>
  <div
    class="doctor-list d-flex align-items-center overflow-hidden"
    :class="!!size ? 'doctor-list-size-' + size : ''"
    v-if="doctors && doctors.length"
  >
    <!-- todo: favour searched doctor names -->
    <span
      class="text-muted d-inline doctor-img"
      :class="{ pp: !!doctor.img, 'no-resize': preventResizeOnHover }"
      v-for="doctor in visible"
      :key="doctor.id"
      @click.prevent="isModalVisible = true"
    >
      <img
        class="rounded-circle img-fluid"
        :src="
          doctor.img ||
          `https://placehold.co/30/${color || '519f85'}/fff?font=lato&text=${
            doctor.first_name[0] + doctor.last_name[0]
          }`
        "
        :alt="`Dr. ${doctor.first_name} ${doctor.last_name}`"
      />
    </span>
    <div class="doctor-name-list ml-2 overflow-hidden" @click.prevent="isModalVisible = true">
      <span class="font-weight-bolder text-overflow doctor-name d-block">
        {{ names }}
      </span>
      <a href="#" @click.prevent="isModalVisible = true" class="d-block font-weight-bolder" v-if="hidden > 0"
        >+ {{ hidden }} more doctor<template v-if="hidden > 1">s</template></a
      >
    </div>

    <modal
      :show="isModalVisible"
      @close="isModalVisible = false"
      class="modal-small prompt-modal modal-auto-width"
      :persist="false"
      containerClass="py-3 px-5"
    >
      <div class="modal-body d-flex flex-column">
        <div
          v-for="(doctor, i) in doctors"
          :key="doctor.id"
          class="d-flex align-items-center"
          :class="{ 'mt-3': i > 0 }"
        >
          <img
            class="rounded-circle img-fluid"
            style="height: 48px; width: 48px"
            :src="
              doctor.img ||
              `https://placehold.co/30/${color || '519f85'}/fff?font=lato&text=${
                doctor.first_name[0] + doctor.last_name[0]
              }`
            "
            :alt="`Dr. ${doctor.first_name} ${doctor.last_name}`"
          />
          <h5 class="text-overflow doctor-name ml-3 d-block" style="font-size: 1rem">
            Dr. {{ doctor.first_name }} {{ doctor.last_name }}
          </h5>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  props: ['doctors', 'size', 'preventResizeOnHover', 'color', 'maxDoctors'],
  components: { Modal },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    maxShowDoctors() {
      return this.maxDoctors || 3
    },
    names() {
      return 'Dr. ' + this.visible.map((s) => `${s.last_name}`).join(', ')
    },
    visible() {
      const max = this.maxShowDoctors
      return this.doctors.slice(0, this.doctors.length == max ? max : max)
    },
    hidden() {
      return this.doctors.length - this.maxShowDoctors
    },
  },
}
</script>

<style lang="scss" scoped>
// .doctor-list {
//   &:hover {
//     margin-left: -20px;
//     .doctor-img {
//       margin-left: -14px;
//       &:hover {
//       }
//     }
//   }
// }
.doctor-img {
  position: relative;
  margin-left: -10px;
  cursor: pointer;
  &:first-child {
    margin-left: 0px;
  }
  img {
    min-width: 30px;
    width: 30px;
    height: 30px;
    display: inline;
    transition: width 0.1s ease-in-out, height 0.1s ease-in-out;
    border-radius: 50%;
    border: solid var(--border-color) 2px;
    background: white;
  }
  &.pp:hover {
    z-index: 999;
    height: 42px;
    min-width: 42px;
    width: 42px;
    // height: 48px;
    img {
      height: 42px;
      min-width: 42px;
      width: 42px;
      border: solid var(--border-color) 1px;
    }
  }
  &.pp.no-resize:hover {
    height: 30px;
    min-width: 30px;
    width: 30px;
    img {
      height: 30px;
      min-width: 30px;
      width: 30px;
    }
  }
}
.doctor-name-list {
  .doctor-name {
    letter-spacing: -0.5px;
    cursor: pointer;
  }
}

.doctor-list-size-sm {
  margin-left: -8px;
  .doctor-img {
    img {
      min-width: 24px;
      width: 24px;
      height: 24px;
    }
    &.pp:hover {
      height: 32px;
      min-width: 32px;
      width: 32px;
      img {
        height: 32px;
        min-width: 32px;
        width: 32px;
      }
    }
    &.pp.no-resize:hover {
      height: 24px;
      min-width: 24px;
      width: 24px;
      img {
        height: 24px;
        min-width: 24px;
        width: 24px;
      }
    }
  }
}
</style>